import { transparentize } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';

import { ModalRaw } from '@main/core-ui';
import { Button, standardFocusStyles } from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';

/**
 * Wrapper take control button
 */
export const TakeControlWrapper = styled.div`
  ${responsive.atLeastDesktop} {
    margin: 0 ${sp(1)};
  }
`;

/**
 * Override some modal styling
 */
export const ClassOverrides = createGlobalStyle`
  .ant-modal-close {
    &:focus {
      i {
        transition: all 0.3s;
        border-radius: 4px;
        ${standardFocusStyles}
      }
    }
  }
`;

/**
 * The primary CTA Take Control button wrapper
 */
export const ButtonWrapper = styled(Button)`
  ${responsive.beforeDesktop} {
    box-shadow: 0 ${sp(0.5)} ${sp(2)}
      ${({ theme }) => transparentize(0.5, theme.colors.black)};
    padding-top: ${sp(1.8)};
    padding-bottom: ${sp(1.8)};
  }
`;

/**
 * The Header Wrapper
 */
export const HeaderWrapper = styled.h3`
  font-size: ${sp(2.8)};
  color: ${({ theme }) => theme.colors.black};
  margin-top: ${sp(3)};
`;

/**
 * The Description Wrapper
 */
export const DescriptionWrapper = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${sp(2)};
  margin: ${sp(0.2)} 0;

  ${responsive.atLeastTablet} {
    padding: 0 ${sp(1.8)};
  }

  ${responsive.atLeastDesktop} {
    padding: 0 ${sp(4)};
  }
`;

/**
 * The Text Wrapper
 */
export const TextWrapper = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  margin: 0 ${sp(1)} ${sp(4)} ${sp(1)};

  ${responsive.atLeastTablet} {
    margin: ${sp(2)} ${sp(8)} ${sp(4)} ${sp(8)};
  }
`;

/**
 * The Data Subject message Wrapper
 */
export const DataSubjectWrapper = styled.div`
  text-align: center;
  font-size: ${sp(2)};
  color: ${({ theme }) => theme.colors.black};
  margin: ${sp(4)} 0 ${sp(0.5)} 0;

  ${responsive.atLeastTablet} {
    margin: ${sp(4)} ${sp(8)} ${sp(0.5)} ${sp(8)};
  }
`;

/**
 * The Data Subject localized title value Wrapper
 */
export const DataSubjectValueWrapper = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`;

/**
 * The Title Wrapper
 */
export const TitleWrapper = styled.h3`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${sp(3)};
  line-height: ${sp(4)};
  margin-bottom: ${sp(2)};
`;

/**
 * The Select Subject Modal Wrapper
 */
export const SelectSubjectModalWrapper = styled.section`
  padding: ${sp(4)} 0 ${sp(4.5)} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/**
 * The Modal Wrapper
 */
export const ModalWrapper = styled.section`
  padding-top: ${sp(5)};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.atLeastTablet} {
    padding: ${sp(6)} ${sp(5)} ${sp(3)} ${sp(5)};
  }

  ${responsive.atLeastDesktop} {
    padding: ${sp(6)} ${sp(10)} ${sp(5)} ${sp(10)};
  }
`;

/**
 * The TakeControlModal wrapper
 */
export const TakeControlModalWrapper = styled.section`
  ${responsive.beforeDesktop} {
    z-index: 1000;
    width: fit-content;
    bottom: ${sp(8)};
    position: fixed;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledModal = styled(ModalRaw)`
  & .modal-dialog {
    max-width: ${sp(122)};
    width: calc(100% - 24px);
  }

  & .modal-body {
    padding: ${sp(2)};
  }
`;
